export default "__VITE_ASSET__crCqAkKh__"